import {createFileRoute} from '@tanstack/react-router'

import Login from '@no-auth/Login'

export const Route = createFileRoute('/_public/login')({component: Login})
